<script setup lang="ts">
import { faArrowRightFromBracket } from '@fortawesome/pro-duotone-svg-icons'

const { data, suspense } = useLayoutCmsData()

await suspense()

const cta = computed(() => data.value?.components?.footerCta)
</script>

<template>
  <section v-if="cta" class="bg-white overflow-x-hidden">
    <ContentGrid>
      <section class="full-width-content grid grid-cols-subgrid">
        <div class="flex flex-col gap-l my-3xl col-span-full lg:col-span-5">
          <div>
            <p class="title-xl" v-text="cta.title" />
            <p class="title-xl !font-normal" v-text="cta.subtitle" />
          </div>
          <CrystallizeRichText v-for="(block, i) in cta.text" :key="i" class="text-2xl font-heading font-light" :block="block" />

          <div class="flex flex-col md:flex-row gap-s md:gap-m md:items-center">
            <Button target="_blank" :icon="faArrowRightFromBracket" icon-position="left" variant="primary" color="moss" size="medium" :to="{ name: 'oversikt-index' }">
              Bruk Juridika
            </Button>
            <Button variant="secondary" color="moss" size="small" :to="{ name: 'product-catalogue' }">
              Finn ditt abonnement
            </Button>
          </div>
        </div>
        <div class="hidden lg:block col-span-3 2xl:col-span-4 2xl:col-start-7 self-end">
          <CrystallizeImage :image="cta.image?.firstImage" />
        </div>
      </section>
    </ContentGrid>
  </section>
</template>
